export default "__VITE_ASSET__5f5c98b5__"